<!-- 个人资料页面：修改显示名与密码（所有角色可访问） -->
<template>
  <div class="profile-page" v-loading="loading">
    <el-card class="box-card" header="个人资料">
      <el-form :model="profileForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="user.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="显示名称">
          <el-input
            v-model="profileForm.display_name"
            placeholder="请输入显示名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveProfile">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" header="修改密码" style="margin-top: 16px">
      <el-form :model="pwdForm" label-width="100px">
        <el-form-item label="原密码">
          <el-input
            v-model="pwdForm.old_password"
            type="password"
            show-password
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input
            v-model="pwdForm.new_password"
            type="password"
            show-password
            placeholder="至少8位且包含字母与数字"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            v-model="pwdForm.confirm"
            type="password"
            show-password
            placeholder="再次输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changePassword">修改密码</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, computed } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { UserServiceApi } from "@/services/dataService";

const store = useStore();
const user = computed(() => store.getters.getUser || { username: "" });
const loading = ref(false);

const profileForm = reactive({ display_name: user.value?.display_name || "" });
const pwdForm = reactive({ old_password: "", new_password: "", confirm: "" });

const saveProfile = async () => {
  loading.value = true;
  try {
    const resp = await UserServiceApi.updateMyProfile(profileForm.display_name);
    const ok =
      (resp as { data?: { code?: number; message?: string } }).data?.code === 0;
    if (ok) {
      ElMessage.success("个人资料已更新");
      await store.dispatch("fetchUserInfo");
    } else {
      const msg =
        (resp as { data?: { message?: string } }).data?.message || "更新失败";
      ElMessage.error(msg);
    }
  } finally {
    loading.value = false;
  }
};

const changePassword = async () => {
  if (!pwdForm.old_password || !pwdForm.new_password) {
    ElMessage.warning("请输入完整的密码信息");
    return;
  }
  if (pwdForm.new_password !== pwdForm.confirm) {
    ElMessage.warning("两次输入的新密码不一致");
    return;
  }
  loading.value = true;
  try {
    const resp = await UserServiceApi.updateMyPassword(
      pwdForm.old_password,
      pwdForm.new_password
    );
    const ok =
      (resp as { data?: { code?: number; message?: string } }).data?.code === 0;
    if (ok) {
      ElMessage.success("密码已更新");
      Object.assign(pwdForm, {
        old_password: "",
        new_password: "",
        confirm: "",
      });
    } else {
      const msg =
        (resp as { data?: { message?: string } }).data?.message || "修改失败";
      ElMessage.error(msg);
    }
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.profile-page {
  padding: 16px;
}
</style>
